/* eslint-disable key-spacing, no-multi-spaces */
import { CountryIso } from './Region';

export const PricingRegion = {
  AUS: 'AUS',
  CAN: 'CAN',
  GBR: 'GBR',
  IRL: 'IRL',
  NZL: 'NZL',
  USA: 'USA',
  EUE: 'EUE',
  ROW: 'ROW',
};

const _PricingRegionIso = {
  [CountryIso.AUSTRALIA]: PricingRegion.AUS,
  [CountryIso.CANADA]: PricingRegion.CAN,
  [CountryIso.GREAT_BRITAIN]: PricingRegion.GBR,
  [CountryIso.IRELAND]: PricingRegion.IRL,
  [CountryIso.NEW_ZEALAND]: PricingRegion.NZL,
  [CountryIso.UNITED_STATES]: PricingRegion.USA,
  [CountryIso.AUSTRIA]: PricingRegion.EUE,
  [CountryIso.BELGIUM]: PricingRegion.EUE,
  [CountryIso.BULGARIA]: PricingRegion.EUE,
  [CountryIso.CYPRUS]: PricingRegion.EUE,
  [CountryIso.CZECH_REPUBLIC]: PricingRegion.EUE,
  [CountryIso.DENMARK]: PricingRegion.EUE,
  [CountryIso.ESTONIA]: PricingRegion.EUE,
  [CountryIso.FINLAND]: PricingRegion.EUE,
  [CountryIso.FRANCE]: PricingRegion.EUE,
  [CountryIso.GERMANY]: PricingRegion.EUE,
  [CountryIso.GREECE]: PricingRegion.EUE,
  [CountryIso.HUNGARY]: PricingRegion.EUE,
  [CountryIso.ITALY]: PricingRegion.EUE,
  [CountryIso.LATVIA]: PricingRegion.EUE,
  [CountryIso.LITHUANIA]: PricingRegion.EUE,
  [CountryIso.LUXEMBOURG]: PricingRegion.EUE,
  [CountryIso.MALTA]: PricingRegion.EUE,
  [CountryIso.NETHERLANDS]: PricingRegion.EUE,
  [CountryIso.NORWAY]: PricingRegion.EUE,
  [CountryIso.POLAND]: PricingRegion.EUE,
  [CountryIso.PORTUGAL]: PricingRegion.EUE,
  [CountryIso.ROMANIA]: PricingRegion.EUE,
  [CountryIso.SLOVAKIA]: PricingRegion.EUE,
  [CountryIso.SLOVENIA]: PricingRegion.EUE,
  [CountryIso.SPAIN]: PricingRegion.EUE,
  [CountryIso.SWEDEN]: PricingRegion.EUE,
  [CountryIso.SWITZERLAND]: PricingRegion.EUE,
  [CountryIso.EUROPEAN_UNION]: PricingRegion.EUE,
  [CountryIso.REST_OF_THE_WORLD]: PricingRegion.ROW,
};

export const getPricingRegionByCountryIso = (iso) => {
  return _PricingRegionIso[iso] ?? CountryIso.REST_OF_THE_WORLD;
};
